<template>
  <div>
    <div class="wrapp">
      <div v-if="loading" class="container">
        <div class="row">
          <div class="col-12 text-center mt-5">
            <b-spinner
              type="grow"
              style="color: #4ce595; width: 3rem; height: 3rem"
              label="Large Spinner"
            ></b-spinner>
          </div>
        </div>
      </div>
      <div v-else-if="displayClosingMessage" class="container header-safe-area">
        <div
          v-if="researchInfo.closingMessageEnabled && closingMessage.html"
          class="row"
        >
          <div class="col-12">
            <div v-if="closingMessage.useLogo" class="row">
              <div class="col-12 mt-3">
                <div class="text-center">
                  <img :src="logo" style="height: 75px; max-width: 100%" />
                </div>
              </div>
            </div>

            <div class="row">
              <div
                class="col-12 mb-4 mt-4 closing-message-area"
                v-html="closingMessage.html"
              />
            </div>
          </div>
        </div>
        <div v-else class="row">
          <thankYouPage :lang="langView" />
          <!-- <div class="col-12 text-center mt-4 closing-message-area">
            <span><i class="far fa-smile"></i></span>
            <h4 class="mt-4">
              {{ $t('researchPage.title') }}
            </h4>
            <span>
              {{ $t('researchPage.firstMsg') }}
            </span>
            <span>
              {{ $t('researchPage.secondMsg') }}
            </span>
          </div> -->
        </div>
        <div class="row" v-if="researchInfo.action.reloadPage">
          <div class="col-12 text-center">
            <div style="padding-left: 70px; padding-right: 70px; margin: 20px">
              <b-progress
                variant="secondary"
                :value="timerValue"
                height="4px"
              ></b-progress>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="error" class="container">
        <div class="row">
          <searchAnswered
            v-if="error !== 'Survey not found for this id.'"
            :lang="langView"
            :situationSearch="
              error ===
              'Essa pesquisa já foi expirada. Agradecemos sua participação.'
                ? 'searchExpired'
                : 'searchAnswered'
            "
          />
          <searchNotFound
            v-else
            :lang="langView"
            :situationSearch="`Survey not found for this id.`"
          />
        </div>
      </div>
      <div v-else-if="researchInfo.action.paused" class="container">
        <Unavailable />
      </div>
      <div
        v-else
        class="container"
        :style="{
          backgroundColor:
            researchInfo.action.email.template.scale !== 'colors'
              ? researchInfo.action.email.template.background
              : '#ffffff',
        }"
      >
        <div class="pt-2" v-if="researchInfo.enableTranslation">
          <b-button-group>
            <b-button
              v-if="researchInfo.action.email.template.enableMyHTMLPt"
              class="btn"
              @click="setLangView('br')"
              :variant="langView === 'br' ? 'primary' : ''"
              ><country-flag country="br" size="normal"
            /></b-button>
            <b-button
              v-if="researchInfo.action.email.template.enableMyHTMLEn"
              class="btn"
              @click="setLangView('us')"
              :variant="langView === 'us' ? 'primary' : ''"
              ><country-flag country="us" size="normal"
            /></b-button>
            <b-button
              v-if="researchInfo.action.email.template.enableMyHTMLEs"
              class="btn"
              @click="setLangView('es')"
              :variant="langView === 'es' ? 'primary' : ''"
              ><country-flag country="es" size="normal"
            /></b-button>
          </b-button-group>
        </div>

        <div v-if="researchInfo.useLogo" class="row">
          <div class="col-12 mt-3">
            <div class="text-center">
              <img :src="logo" style="height: 75px; max-width: 100%" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div id="body-email-modal" class="mt-3 mb-4" v-html="text" />
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <template v-if="questionHTML">
              <div class="text-center">
                <div v-html="questionHTML"></div>
              </div>
            </template>
            <template v-else>
              <div class="text-center">
                {{ question }}
              </div>
            </template>
            <methodology
              :lang="langView"
              :surveySelectedColor="
                researchInfo.action.email.template.templatebuttonselected
              "
              :surveyColor="researchInfo.action.email.template.scale || 'colors'"
              :actionMetric="researchInfo.metric"
              :isLinkQrCode="true"
              class="mt-4 mb-3"
            />
          </div>
        </div>

        <div v-if="researchInfo.commentPosition === 'up'" class="row mb-4">
          <div class="col-12">
            <div class="feedback-area mt-4" v-if="langView === 'br'">
              <research-replys
                v-if="!researchInfo.action.feedbackDisabled"
                :style="{
                  color:
                    researchInfo.action.email.template.scale !== 'colors'
                      ? researchInfo.action.email.template.backgroundtext
                      : '#000000',
                }"
                :metric="researchInfo.metric"
                :promotersReply="promotersQuestion"
                :neutralReply="neutralQuestion"
                :detractorsReply="detractorsQuestion"
                :grade="testNpsReview"
              />
              <span v-if="displayRequiredFields" class="required mt-2">
                *Obrigatório
              </span>
              <textarea
                v-if="!researchInfo.action.feedbackDisabled"
                v-model="feedback"
                name=""
                id="feedback"
                class="form-control"
                rows="4"
              ></textarea>
            </div>
            <div class="feedback-area mt-4" v-if="langView === 'us'">
              <research-replys
                v-if="!researchInfo.action.feedbackDisabled"
                :defaultFeedback="'What is the main reason for your grade?'"
                :metric="researchInfo.metric"
                :promotersReply="
                  researchInfo.action.reply.languageSupport.promotersEN
                "
                :neutralReply="
                  researchInfo.action.reply.languageSupport.neutralEN
                "
                :detractorsReply="
                  researchInfo.action.reply.languageSupport.detractorsEN
                "
                :grade="testNpsReview"
              />
              <span v-if="displayRequiredFields" class="required mt-2">
                *Required
              </span>
              <textarea
                v-if="!researchInfo.action.feedbackDisabled"
                v-model="feedback"
                name=""
                id="feedback"
                class="form-control"
                rows="4"
              ></textarea>
            </div>
            <div class="feedback-area mt-4" v-if="langView === 'es'">
              <research-replys
                v-if="!researchInfo.action.feedbackDisabled"
                :defaultFeedback="'¿Cuál es la razón principal de tu calificación?'"
                :metric="researchInfo.metric"
                :promotersReply="
                  researchInfo.action.reply.languageSupport.promotersES
                "
                :neutralReply="
                  researchInfo.action.reply.languageSupport.neutralES
                "
                :detractorsReply="
                  researchInfo.action.reply.languageSupport.detractorsES
                "
                :grade="testNpsReview"
              />
              <span v-if="displayRequiredFields" class="required mt-2">
                *Requerido
              </span>
              <textarea
                v-if="!researchInfo.action.feedbackDisabled"
                v-model="feedback"
                name=""
                id="feedback"
                class="form-control"
                rows="4"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="row mt-2">
          <div class="col-12">
            <hr v-if="researchInfo.additionalQuestions.length > 0" />
            <div v-for="(item, i) in researchInfo.additionalQuestions" :key="i">
              <div v-if="indicatorValuedQuestion(item)">
                <template v-if="item.profileEnabled">
                  <template
                    v-if="
                      item.selectedProfile &&
                      item.selectedProfile.includes(conditionalQuestion())
                    "
                  >
                    <template
                      v-if="
                        promotersGrades.includes(testNpsReview) ||
                        detractorsGrades.includes(testNpsReview) ||
                        passivesGrades.includes(testNpsReview)
                      "
                    >
                      <!-- all mandatory questions -->
                      <span
                        v-if="displayRequiredFields && item.type !== 'LABEL'"
                        class="required"
                      >
                        *Obrigatório
                      </span>
                      <!-- -->

                      <!-- specific mandatory questions -->
                      <div
                        v-show="
                          verifyExistsDom(item.id) &&
                          showMessage &&
                          item.mandatory &&
                          item.type !== 'LABEL' &&
                          item.addQuestionAnswer &&
                          item.addQuestionAnswer.review === null
                        "
                      >
                        <span class="required"> *Obrigatório </span>
                      </div>

                      <div
                        v-show="
                          verifyExistsDom(item.id) &&
                          showMessage &&
                          item.mandatory &&
                          item.type === 'MULTIPLE' &&
                          item.addQuestionAnswerMultiple &&
                          item.addQuestionAnswerMultiple.multipleValues &&
                          item.addQuestionAnswerMultiple.multipleValues
                            .length === 0
                        "
                      >
                        <span class="required"> *Obrigatório</span>
                      </div>

                      <div
                        v-show="
                          (verifyExistsDom(item.id) &&
                            showMessage &&
                            item.mandatory &&
                            (item.type === 'INPUT' ||
                              item.type === 'INPUT-CPF') &&
                            !item.answerText) ||
                          (item.answerText && item.answerText.review === null)
                        "
                      >
                        <span class="required"> *Obrigatório</span>
                      </div>
                      <!-- -->

                      <likert
                        v-if="
                          item.type === 'LIKERT' && !item.show && !item.display
                        "
                        :textColor="
                          researchInfo.action.email.template.scale !== 'colors'
                            ? researchInfo.action.email.template.backgroundtext
                            : '#000000'
                        "
                        :text="
                          langView === 'br'
                            ? item.text
                            : langView === 'us'
                            ? item.textEN
                            : item.textES
                        "
                        :item-id="i.toString()"
                        :index="i"
                        :colorTemplate="researchInfo.scale"
                        :commentEnabled="item.commentEnabled"
                        v-model="item.addQuestionAnswer"
                        :applicableEnabled="item.applicableEnabled"
                        :reviewAnswer="testNpsReview ? testNpsReview : -99"
                        :addQuestionTemplate="researchInfo.addQuestionTemplate"
                        @input="getReview"
                        :id="item.id"
                        :template="item.template"
                        :lang="langView"
                        :idQuestion="item.id"
                      />
                      <c-sat
                        v-if="
                          item.type === 'CSAT' && !item.show && !item.display
                        "
                        :textColor="
                          researchInfo.action.email.template.scale !== 'colors'
                            ? researchInfo.action.email.template.backgroundtext
                            : '#000000'
                        "
                        :text="
                          langView === 'br'
                            ? item.text
                            : langView === 'us'
                            ? item.textEN
                            : item.textES
                        "
                        :item-id="i.toString()"
                        :index="i"
                        :colorTemplate="researchInfo.scale"
                        v-model="item.addQuestionAnswer"
                        :commentEnabled="item.commentEnabled"
                        :applicableEnabled="item.applicableEnabled"
                        :reviewAnswer="testNpsReview ? testNpsReview : -99"
                        :addQuestionTemplate="researchInfo.addQuestionTemplate"
                        @input="getReview"
                        :id="item.id"
                        :template="item.template"
                        :idQuestion="item.id"
                        :lang="langView"
                      />

                      <star-rating
                        v-if="
                          item.type === 'REVIEWS' && !item.show && !item.display
                        "
                        :textColor="
                          researchInfo.action.email.template.scale !== 'colors'
                            ? researchInfo.action.email.template.backgroundtext
                            : '#000000'
                        "
                        :text="
                          langView === 'br'
                            ? item.text
                            : langView === 'us'
                            ? item.textEN
                            : item.textES
                        "
                        :item-id="i.toString()"
                        :index="i"
                        v-model="item.addQuestionAnswer"
                        :commentEnabled="item.commentEnabled"
                        :applicableEnabled="item.applicableEnabled"
                        :reviewAnswer="testNpsReview ? testNpsReview : -99"
                        :addQuestionTemplate="researchInfo.addQuestionTemplate"
                        @input="getReview"
                        :id="item.id"
                        :idQuestion="item.id"
                        :lang="langView"
                      />
                      <like-dislike
                        v-if="
                          item.type === 'LIKE/DISLIKE' &&
                          !item.show &&
                          !item.display
                        "
                        :textColor="
                          researchInfo.action.email.template.scale !== 'colors'
                            ? researchInfo.action.email.template.backgroundtext
                            : '#000000'
                        "
                        :questionText="item.text"
                        :index="i"
                        v-model="item.addQuestionAnswer"
                        :commentEnabled="item.commentEnabled"
                        :applicableEnabled="item.applicableEnabled"
                        :reviewAnswer="testNpsReview ? testNpsReview : -99"
                        :addQuestionTemplate="researchInfo.addQuestionTemplate"
                        @input="getReview"
                        :text="
                          langView === 'br'
                            ? item.text
                            : langView === 'us'
                            ? item.textEN
                            : item.textES
                        "
                        :id="item.id"
                        :item-id="i.toString()"
                        :idQuestion="item.id"
                        :lang="langView"
                      />
                      <emotion
                        v-if="
                          item.type === 'EMOTION' && !item.show && !item.display
                        "
                        :textColor="
                          researchInfo.action.email.template.scale !== 'colors'
                            ? researchInfo.action.email.template.backgroundtext
                            : '#000000'
                        "
                        :questionText="item.text"
                        :index="i"
                        v-model="item.addQuestionAnswer"
                        :commentEnabled="item.commentEnabled"
                        :applicableEnabled="item.applicableEnabled"
                        :reviewAnswer="testNpsReview ? testNpsReview : -99"
                        :addQuestionTemplate="researchInfo.addQuestionTemplate"
                        @input="getReview"
                        :text="
                          langView === 'br'
                            ? item.text
                            : langView === 'us'
                            ? item.textEN
                            : item.textES
                        "
                        :id="item.id"
                        :item-id="i.toString()"
                        :idQuestion="item.id"
                        :lang="langView"
                      />

                      <multiple-choices
                        :item-id="i.toString()"
                        v-if="
                          item.type === 'MULTIPLE' &&
                          item.template !== 'withSubOptions' &&
                          !item.show &&
                          !item.display
                        "
                        :textColor="
                          researchInfo.action.email.template.scale !== 'colors'
                            ? researchInfo.action.email.template.backgroundtext
                            : '#000000'
                        "
                        :type="item.multipleType"
                        :questionText="item.text"
                        :choices="item.choices"
                        :index="i"
                        v-model="item.addQuestionAnswerMultiple"
                        :commentEnabled="item.commentEnabled"
                        :applicableEnabled="item.applicableEnabled"
                        :reviewAnswer="testNpsReview ? testNpsReview : -99"
                        :addQuestionTemplate="researchInfo.addQuestionTemplate"
                        @input="getReview"
                        :text="
                          langView === 'br'
                            ? item.text
                            : langView === 'us'
                            ? item.textEN
                            : item.textES
                        "
                        :id="item.id"
                        :lang="langView"
                        :idQuestion="item.id"
                        :pageBackground="
                          researchInfo.action.email.template.scale !== 'colors'
                            ? researchInfo.action.email.template.background
                            : ''
                        "
                        :limitChoices="item.maximumAmountSelection"
                      />

                      <multiple-choices-custom
                        :item-id="i.toString()"
                        v-if="
                          item.type === 'MULTIPLE' &&
                          item.template === 'withSubOptions' &&
                          !item.show &&
                          !item.display
                        "
                        :textColor="
                          researchInfo.action.email.template.scale !== 'colors'
                            ? researchInfo.action.email.template.backgroundtext
                            : '#000000'
                        "
                        :type="item.multipleType"
                        :questionText="item.text"
                        :choices="item.choices"
                        :index="i"
                        v-model="item.addQuestionAnswerMultiple"
                        :commentEnabled="item.commentEnabled"
                        :applicableEnabled="item.applicableEnabled"
                        :reviewAnswer="testNpsReview ? testNpsReview : -99"
                        :addQuestionTemplate="researchInfo.addQuestionTemplate"
                        @input="getReview"
                        :text="
                          langView === 'br'
                            ? item.text
                            : langView === 'us'
                            ? item.textEN
                            : item.textES
                        "
                        :id="item.id"
                        :lang="langView"
                        :idQuestion="item.id"
                        :limitChoices="item.maximumAmountSelection"
                      />
                      <label-question
                        v-if="
                          item.type === 'LABEL' && !item.show && !item.display
                        "
                        :textColor="
                          researchInfo.action.email.template.scale !== 'colors'
                            ? researchInfo.action.email.template.backgroundtext
                            : '#000000'
                        "
                        :text="item.text"
                        :addQuestionTemplate="researchInfo.addQuestionTemplate"
                        :item-id="i.toString()"
                        :idQuestion="item.id"
                      />
                      <ces
                        v-if="
                          item.type === 'CES' && !item.show && !item.display
                        "
                        :textColor="
                          researchInfo.action.email.template.scale !== 'colors'
                            ? researchInfo.action.email.template.backgroundtext
                            : '#000000'
                        "
                        :text="
                          langView === 'br'
                            ? item.text
                            : langView === 'us'
                            ? item.textEN
                            : item.textES
                        "
                        :item-id="i.toString()"
                        :index="i"
                        :colorTemplate="researchInfo.scale"
                        v-model="item.addQuestionAnswer"
                        :commentEnabled="item.commentEnabled"
                        :applicableEnabled="item.applicableEnabled"
                        :reviewAnswer="testNpsReview ? testNpsReview : -99"
                        :addQuestionTemplate="researchInfo.addQuestionTemplate"
                        @input="getReview"
                        :id="item.id"
                        :idQuestion="item.id"
                        :lang="langView"
                      />
                      <input-type
                        v-if="
                          item.type === 'INPUT' && !item.show && !item.display
                        "
                        :textColor="
                          researchInfo.action.email.template.scale !== 'colors'
                            ? researchInfo.action.email.template.backgroundtext
                            : '#000000'
                        "
                        :text="
                          langView === 'br'
                            ? item.text
                            : langView === 'us'
                            ? item.textEN
                            : item.textES
                        "
                        :item-id="i.toString()"
                        :index="i"
                        v-model="item.answerText"
                        :addQuestionTemplate="researchInfo.addQuestionTemplate"
                        @input="getReview"
                        :isMandatoryForQuestion="researchInfo.mandatory"
                        :id="item.id"
                        :placeholder="
                          langView === 'br'
                            ? 'Preencha aqui'
                            : langView === 'us'
                            ? 'Write here'
                            : 'Escribe aquí'
                        "
                        :idQuestion="item.id"
                      />

                      <input-type-cpf
                        v-model="cpf"
                        v-if="
                          item.type === 'INPUT-CPF' &&
                          !item.show &&
                          !item.display
                        "
                        :textColor="
                          action.email.template.scale !== 'colors'
                            ? action.email.template.backgroundtext
                            : '#000000'
                        "
                        :text="item.text"
                        :index="i"
                        :item-id="i.toString()"
                        :addQuestionTemplate="researchInfo.addQuestionTemplate"
                        :isMandatoryForQuestion="researchInfo.mandatory"
                        @input="getReview"
                        :id="item.id"
                        :placeholder="
                          langView === 'br'
                            ? 'Preencha aqui'
                            : langView === 'us'
                            ? 'Write here'
                            : 'Escribe aquí'
                        "
                        :idQuestion="item.id"
                      />
                      <span
                        class="required"
                        v-if="
                          displayInvalidCpf &&
                          item.type === 'INPUT-CPF' &&
                          !item.show &&
                          !item.display
                        "
                        >Não foi possível identificar, por favor, tente
                        novamente!</span
                      >

                      <nps
                        v-if="
                          item.type === 'NPS' && !item.show && !item.display
                        "
                        :textColor="
                          researchInfo.action.email.template.scale !== 'colors'
                            ? researchInfo.action.email.template.backgroundtext
                            : '#000000'
                        "
                        :text="
                          langView === 'br'
                            ? item.text
                            : langView === 'us'
                            ? item.textEN
                            : item.textES
                        "
                        :item-id="i.toString()"
                        :index="i"
                        :colorTemplate="researchInfo.scale"
                        v-model="item.addQuestionAnswer"
                        :commentEnabled="item.commentEnabled"
                        :applicableEnabled="item.applicableEnabled"
                        :reviewAnswer="testNpsReview ? testNpsReview : -99"
                        :addQuestionTemplate="researchInfo.addQuestionTemplate"
                        @input="getReview"
                        :id="item.id"
                        :template="item.template"
                        :idQuestion="item.id"
                        :lang="langView"
                      />

                      <likertEmotion
                        v-if="
                          item.type === 'LIKERT/EMOTION' &&
                          !item.show &&
                          !item.display
                        "
                        :textColor="
                          researchInfo.action.email.template.scale !== 'colors'
                            ? researchInfo.action.email.template.backgroundtext
                            : '#000000'
                        "
                        :text="
                          langView === 'br'
                            ? item.text
                            : langView === 'us'
                            ? item.textEN
                            : item.textES
                        "
                        :item-id="i.toString()"
                        :index="i"
                        :colorTemplate="researchInfo.scale"
                        v-model="item.addQuestionAnswer"
                        :commentEnabled="item.commentEnabled"
                        :applicableEnabled="item.applicableEnabled"
                        :reviewAnswer="testNpsReview ? testNpsReview : -99"
                        :addQuestionTemplate="researchInfo.addQuestionTemplate"
                        @input="getReview"
                        :id="item.id"
                        :idQuestion="item.id"
                        :lang="langView"
                      />
                    </template>
                  </template>
                </template>
                <template v-else>
                  <!-- all mandatory questions -->

                  <span
                    v-if="
                      verifyExistsDom(item.id) &&
                      displayRequiredFields &&
                      item.type !== 'LABEL'
                    "
                    class="required"
                  >
                    *Obrigatório
                  </span>
                  <!-- -->

                  <!-- specific mandatory questions -->
                  <div
                    v-show="
                      verifyExistsDom(item.id) &&
                      showMessage &&
                      item.mandatory &&
                      item.type !== 'LABEL' &&
                      item.addQuestionAnswer &&
                      item.addQuestionAnswer.review === null
                    "
                  >
                    <span class="required"> *Obrigatório</span>
                  </div>

                  <div
                    v-show="
                      verifyExistsDom(item.id) &&
                      showMessage &&
                      item.mandatory &&
                      item.type === 'MULTIPLE' &&
                      item.addQuestionAnswerMultiple &&
                      item.addQuestionAnswerMultiple.multipleValues &&
                      item.addQuestionAnswerMultiple.multipleValues.length === 0
                    "
                  >
                    <span class="required"> *Obrigatório</span>
                  </div>

                  <div
                    v-show="
                      (verifyExistsDom(item.id) &&
                        showMessage &&
                        item.mandatory &&
                        (item.type === 'INPUT' || item.type === 'INPUT-CPF') &&
                        !item.answerText) ||
                      (item.answerText && item.answerText.review === null)
                    "
                  >
                    <span class="required"> *Obrigatório</span>
                  </div>
                  <!-- -->

                  <likert
                    v-if="item.type === 'LIKERT' && !item.show && !item.display"
                    :textColor="
                      researchInfo.action.email.template.scale !== 'colors'
                        ? researchInfo.action.email.template.backgroundtext
                        : '#000000'
                    "
                    :text="
                      langView === 'br'
                        ? item.text
                        : langView === 'us'
                        ? item.textEN
                        : item.textES
                    "
                    :item-id="i.toString()"
                    :index="i"
                    :colorTemplate="researchInfo.scale"
                    v-model="item.addQuestionAnswer"
                    :commentEnabled="item.commentEnabled"
                    :applicableEnabled="item.applicableEnabled"
                    :reviewAnswer="testNpsReview ? testNpsReview : -99"
                    :addQuestionTemplate="researchInfo.addQuestionTemplate"
                    :idQuestion="item.id"
                    @input="getReview"
                    :id="item.id"
                    :template="item.template"
                    :lang="langView"
                  />

                  <c-sat
                    v-if="item.type === 'CSAT' && !item.show && !item.display"
                    :textColor="
                      researchInfo.action.email.template.scale !== 'colors'
                        ? researchInfo.action.email.template.backgroundtext
                        : '#000000'
                    "
                    :text="
                      langView === 'br'
                        ? item.text
                        : langView === 'us'
                        ? item.textEN
                        : item.textES
                    "
                    :item-id="i.toString()"
                    :index="i"
                    :colorTemplate="researchInfo.scale"
                    v-model="item.addQuestionAnswer"
                    :commentEnabled="item.commentEnabled"
                    :applicableEnabled="item.applicableEnabled"
                    :reviewAnswer="testNpsReview ? testNpsReview : -99"
                    :addQuestionTemplate="researchInfo.addQuestionTemplate"
                    :idQuestion="item.id"
                    @input="getReview"
                    :id="item.id"
                    :template="item.template"
                    :lang="langView"
                  />

                  <star-rating
                    v-if="
                      item.type === 'REVIEWS' && !item.show && !item.display
                    "
                    :textColor="
                      researchInfo.action.email.template.scale !== 'colors'
                        ? researchInfo.action.email.template.backgroundtext
                        : '#000000'
                    "
                    :text="
                      langView === 'br'
                        ? item.text
                        : langView === 'us'
                        ? item.textEN
                        : item.textES
                    "
                    :item-id="i.toString()"
                    :index="i"
                    v-model="item.addQuestionAnswer"
                    :commentEnabled="item.commentEnabled"
                    :applicableEnabled="item.applicableEnabled"
                    :reviewAnswer="testNpsReview ? testNpsReview : -99"
                    :addQuestionTemplate="researchInfo.addQuestionTemplate"
                    :idQuestion="item.id"
                    @input="getReview"
                    :id="item.id"
                    :lang="langView"
                  />

                  <like-dislike
                    v-if="
                      item.type === 'LIKE/DISLIKE' &&
                      !item.show &&
                      !item.display
                    "
                    :textColor="
                      researchInfo.action.email.template.scale !== 'colors'
                        ? researchInfo.action.email.template.backgroundtext
                        : '#000000'
                    "
                    :questionText="
                      langView === 'br'
                        ? item.text
                        : langView === 'us'
                        ? item.textEN
                        : item.textES
                    "
                    :index="i"
                    v-model="item.addQuestionAnswer"
                    :item-id="i.toString()"
                    :commentEnabled="item.commentEnabled"
                    :applicableEnabled="item.applicableEnabled"
                    :reviewAnswer="testNpsReview ? testNpsReview : -99"
                    :addQuestionTemplate="researchInfo.addQuestionTemplate"
                    :idQuestion="item.id"
                    @input="getReview"
                    :id="item.id"
                    :lang="langView"
                  />
                  <emotion
                    v-if="
                      item.type === 'EMOTION' && !item.show && !item.display
                    "
                    :textColor="
                      researchInfo.action.email.template.scale !== 'colors'
                        ? researchInfo.action.email.template.backgroundtext
                        : '#000000'
                    "
                    :questionText="
                      langView === 'br'
                        ? item.text
                        : langView === 'us'
                        ? item.textEN
                        : item.textES
                    "
                    :index="i"
                    v-model="item.addQuestionAnswer"
                    :item-id="i.toString()"
                    :commentEnabled="item.commentEnabled"
                    :applicableEnabled="item.applicableEnabled"
                    :reviewAnswer="testNpsReview ? testNpsReview : -99"
                    :addQuestionTemplate="researchInfo.addQuestionTemplate"
                    :idQuestion="item.id"
                    @input="getReview"
                    :id="item.id"
                    :lang="langView"
                  />
                  <multiple-choices
                    v-if="
                      item.type === 'MULTIPLE' &&
                      item.template !== 'withSubOptions' &&
                      !item.show &&
                      !item.display
                    "
                    :textColor="
                      researchInfo.action.email.template.scale !== 'colors'
                        ? researchInfo.action.email.template.backgroundtext
                        : '#000000'
                    "
                    :type="item.multipleType"
                    :questionText="
                      langView === 'br'
                        ? item.text
                        : langView === 'us'
                        ? item.textEN
                        : item.textES
                    "
                    :choices="item.choices"
                    :index="i"
                    v-model="item.addQuestionAnswerMultiple"
                    :commentEnabled="item.commentEnabled"
                    :applicableEnabled="item.applicableEnabled"
                    :reviewAnswer="testNpsReview ? testNpsReview : -99"
                    :addQuestionTemplate="researchInfo.addQuestionTemplate"
                    :item-id="i.toString()"
                    :idQuestion="item.id"
                    @input="getReview"
                    :id="item.id"
                    :lang="langView"
                    :pageBackground="
                      researchInfo.action.email.template.scale !== 'colors'
                        ? researchInfo.action.email.template.background
                        : ''
                    "
                    :limitChoices="item.maximumAmountSelection"
                  />

                  <multiple-choices-custom
                    v-if="
                      item.type === 'MULTIPLE' &&
                      item.template === 'withSubOptions' &&
                      !item.show &&
                      !item.display
                    "
                    :textColor="
                      researchInfo.action.email.template.scale !== 'colors'
                        ? researchInfo.action.email.template.backgroundtext
                        : '#000000'
                    "
                    :type="item.multipleType"
                    :questionText="
                      langView === 'br'
                        ? item.text
                        : langView === 'us'
                        ? item.textEN
                        : item.textES
                    "
                    :choices="item.choices"
                    :index="i"
                    v-model="item.addQuestionAnswerMultiple"
                    :commentEnabled="item.commentEnabled"
                    :applicableEnabled="item.applicableEnabled"
                    :reviewAnswer="testNpsReview ? testNpsReview : -99"
                    :addQuestionTemplate="researchInfo.addQuestionTemplate"
                    :item-id="i.toString()"
                    :idQuestion="item.id"
                    @input="getReview"
                    :id="item.id"
                    :lang="langView"
                    :limitChoices="item.maximumAmountSelection"
                  />

                  <ces
                    v-if="item.type === 'CES' && !item.show && !item.display"
                    :textColor="
                      researchInfo.action.email.template.scale !== 'colors'
                        ? researchInfo.action.email.template.backgroundtext
                        : '#000000'
                    "
                    :text="
                      langView === 'br'
                        ? item.text
                        : langView === 'us'
                        ? item.textEN
                        : item.textES
                    "
                    :item-id="i.toString()"
                    :index="i"
                    :colorTemplate="researchInfo.scale"
                    v-model="item.addQuestionAnswer"
                    :commentEnabled="item.commentEnabled"
                    :applicableEnabled="item.applicableEnabled"
                    :reviewAnswer="testNpsReview ? testNpsReview : -99"
                    :addQuestionTemplate="researchInfo.addQuestionTemplate"
                    :idQuestion="item.id"
                    @input="getReview"
                    :id="item.id"
                    :lang="langView"
                  />
                  <input-type
                    v-if="item.type === 'INPUT' && !item.show && !item.display"
                    :textColor="
                      researchInfo.action.email.template.scale !== 'colors'
                        ? researchInfo.action.email.template.backgroundtext
                        : '#000000'
                    "
                    :text="
                      langView === 'br'
                        ? item.text
                        : langView === 'us'
                        ? item.textEN
                        : item.textES
                    "
                    :item-id="i.toString()"
                    :index="i"
                    v-model="item.answerText"
                    :addQuestionTemplate="researchInfo.addQuestionTemplate"
                    :idQuestion="item.id"
                    @input="getReview"
                    :isMandatoryForQuestion="researchInfo.mandatory"
                    :id="item.id"
                    :placeholder="
                      langView === 'br'
                        ? 'Preencha aqui'
                        : langView === 'us'
                        ? 'Write here'
                        : 'Escribe aquí'
                    "
                  />

                  <input-type-cpf
                    v-model="cpf"
                    v-if="
                      item.type === 'INPUT-CPF' && !item.show && !item.display
                    "
                    :textColor="
                      action.email.template.scale !== 'colors'
                        ? action.email.template.backgroundtext
                        : '#000000'
                    "
                    :text="item.text"
                    :index="i"
                    :item-id="i.toString()"
                    :addQuestionTemplate="researchInfo.addQuestionTemplate"
                    :isMandatoryForQuestion="researchInfo.mandatory"
                    @input="getReview"
                    :id="item.id"
                    :placeholder="
                      langView === 'br'
                        ? 'Preencha aqui'
                        : langView === 'us'
                        ? 'Write here'
                        : 'Escribe aquí'
                    "
                    :idQuestion="item.id"
                  />
                  <span
                    class="required"
                    v-if="displayInvalidCpf && item.type === 'INPUT-CPF'"
                    >Não foi possível identificar, por favor, tente
                    novamente!</span
                  >

                  <label-question
                    v-if="item.type === 'LABEL' && !item.show && !item.display"
                    :textColor="
                      researchInfo.action.email.template.scale !== 'colors'
                        ? researchInfo.action.email.template.backgroundtext
                        : '#000000'
                    "
                    :text="
                      langView === 'br'
                        ? item.text
                        : langView === 'us'
                        ? item.textEN
                        : item.textES
                    "
                    :item-id="i.toString()"
                    :addQuestionTemplate="researchInfo.addQuestionTemplate"
                    :idQuestion="item.id"
                    :id="item.id"
                  />
                  <nps
                    v-if="item.type === 'NPS' && !item.show && !item.display"
                    :textColor="
                      researchInfo.action.email.template.scale !== 'colors'
                        ? researchInfo.action.email.template.backgroundtext
                        : '#000000'
                    "
                    :text="
                      langView === 'br'
                        ? item.text
                        : langView === 'us'
                        ? item.textEN
                        : item.textES
                    "
                    :item-id="i.toString()"
                    :index="i"
                    :colorTemplate="researchInfo.scale"
                    v-model="item.addQuestionAnswer"
                    :commentEnabled="item.commentEnabled"
                    :applicableEnabled="item.applicableEnabled"
                    :reviewAnswer="testNpsReview ? testNpsReview : -99"
                    :addQuestionTemplate="researchInfo.addQuestionTemplate"
                    :idQuestion="item.id"
                    @input="getReview"
                    :id="item.id"
                    :template="item.template"
                    :lang="langView"
                  />

                  <likertEmotion
                    v-if="
                      item.type === 'LIKERT/EMOTION' &&
                      !item.show &&
                      !item.display
                    "
                    :textColor="
                      researchInfo.action.email.template.scale !== 'colors'
                        ? researchInfo.action.email.template.backgroundtext
                        : '#000000'
                    "
                    :text="
                      langView === 'br'
                        ? item.text
                        : langView === 'us'
                        ? item.textEN
                        : item.textES
                    "
                    :item-id="i.toString()"
                    :index="i"
                    :colorTemplate="researchInfo.scale"
                    v-model="item.addQuestionAnswer"
                    :commentEnabled="item.commentEnabled"
                    :applicableEnabled="item.applicableEnabled"
                    :reviewAnswer="testNpsReview ? testNpsReview : -99"
                    :addQuestionTemplate="researchInfo.addQuestionTemplate"
                    :idQuestion="item.id"
                    @input="getReview"
                    :id="item.id"
                    :lang="langView"
                  />
                  <template
                    v-if="
                      action.email.additionalQuestions[i].displayType ===
                        'formSearch' &&
                      !item.show &&
                      !item.display
                    "
                  >
                    <span
                      v-if="displayRequiredFields || contactsRequired"
                      class="required mt-2"
                    >
                      *Campos obrigatórios
                    </span>

                    <contact
                      v-if="
                        item.type === 'CONTACT' && !item.show && !item.display
                      "
                      :textColor="
                        researchInfo.action.email.template.scale !== 'colors'
                          ? researchInfo.action.email.template.backgroundtext
                          : '#000000'
                      "
                      :type="item.multipleType"
                      :questionText="
                        langView === 'br'
                          ? item.text
                          : langView === 'us'
                          ? item.textEN
                          : item.textES
                      "
                      :choices="item.choices"
                      :index="i"
                      v-model="dataContact"
                      :addQuestionTemplate="researchInfo.addQuestionTemplate"
                      :lang="langView"
                      :item-id="i.toString()"
                      :idQuestion="item.id"
                      :name="$route.query.name"
                      :phone="$route.query.phone"
                      :email="$route.query.email"
                    />
                  </template>
                </template>
              </div>
            </div>
          </div>
        </div>

        <div v-if="researchInfo.commentPosition === 'down'" class="row">
          <div class="col-12">
            <div class="feedback-area mt-4" v-if="langView === 'br'">
              <research-replys
                v-if="!researchInfo.action.feedbackDisabled"
                :style="{
                  color:
                    researchInfo.action.email.template.scale !== 'colors'
                      ? researchInfo.action.email.template.backgroundtext
                      : '#000000',
                }"
                :metric="researchInfo.metric"
                :promotersReply="promotersQuestion"
                :neutralReply="neutralQuestion"
                :detractorsReply="detractorsQuestion"
                :grade="testNpsReview"
              />
              <span v-if="displayRequiredFields" class="required mt-2">
                *Obrigatório
              </span>
              <textarea
                v-if="!researchInfo.action.feedbackDisabled"
                v-model="feedback"
                name=""
                id="feedback"
                class="form-control"
                rows="4"
              ></textarea>
            </div>
            <div class="feedback-area mt-4" v-if="langView === 'us'">
              <research-replys
                v-if="!researchInfo.action.feedbackDisabled"
                :defaultFeedback="'What is the main reason for your grade?'"
                :metric="researchInfo.metric"
                :promotersReply="
                  researchInfo.action.reply.languageSupport.promotersEN
                "
                :neutralReply="
                  researchInfo.action.reply.languageSupport.neutralEN
                "
                :detractorsReply="
                  researchInfo.action.reply.languageSupport.detractorsEN
                "
                :grade="testNpsReview"
              />
              <span v-if="displayRequiredFields" class="required mt-2">
                *Required
              </span>
              <textarea
                v-if="!researchInfo.action.feedbackDisabled"
                v-model="feedback"
                name=""
                id="feedback"
                class="form-control"
                rows="4"
              ></textarea>
            </div>
            <div class="feedback-area mt-4" v-if="langView === 'es'">
              <research-replys
                v-if="!researchInfo.action.feedbackDisabled"
                :defaultFeedback="'¿Cuál es la razón principal de tu calificación?'"
                :metric="researchInfo.metric"
                :promotersReply="
                  researchInfo.action.reply.languageSupport.promotersES
                "
                :neutralReply="
                  researchInfo.action.reply.languageSupport.neutralES
                "
                :detractorsReply="
                  researchInfo.action.reply.languageSupport.detractorsES
                "
                :grade="testNpsReview"
              />
              <span v-if="displayRequiredFields" class="required mt-2">
                *Requerido
              </span>
              <textarea
                v-if="!researchInfo.action.feedbackDisabled"
                v-model="feedback"
                name=""
                id="feedback"
                class="form-control"
                rows="4"
              ></textarea>
            </div>
          </div>
        </div>
        <div class="row pt-2" v-if="researchInfo.enableAnonymous">
          <b-form-checkbox
            :disabled="researchInfo.action.allAnswersAnonymous"
            class="check-alert-modal ml-3"
            id="id-anonymous"
            v-model="anonymousResponse"
          >
          </b-form-checkbox>
          <label
            for="id-anonymous"
            :style="{
              color:
                researchInfo.action.email.template.scale !== 'colors'
                  ? researchInfo.action.email.template.backgroundtext
                  : '#000000',
            }"
          >
            {{ researchInfo.enableAnonymous }}
          </label>
        </div>
        <div
          v-if="enabledAudioResponse && !researchInfo.action.feedbackDisabled"
        >
          <audio-recorder
            format="mp3"
            :bit-rate="128"
            upload-url="YOUR_API_URL"
            :attempts="1"
            :time="1"
            :headers="headers"
            :before-recording="callback"
            :pause-recording="callback"
            :after-recording="callback"
            :select-record="callback"
            :before-upload="callback"
            :successful-upload="callback"
            :failed-upload="callback"
          />
        </div>
        <div class="row mt-5">
          <div class="col-12 text-center mt-2 mb-3 btn-send">
            <template v-if="typeModalContact">
              <b-button
                v-b-modal.modal-send
                :style="{
                  boxShadow: `0px 10px 30px -7px ${
                    researchInfo.action.email.template.buttonColor ||
                    '#cccccc'
                  }`,
                  backgroundColor: researchInfo.action.email.template
                    .buttonColor
                    ? researchInfo.action.email.template.buttonColor
                    : '',
                  borderColor: researchInfo.action.email.template
                    .buttonBorderColor
                    ? researchInfo.action.email.template.buttonBorderColor
                    : '',
                  color: researchInfo.action.email.template.buttonTextColor
                    ? researchInfo.action.email.template.buttonTextColor
                    : '',
                }"
                class="btn btn-primary px-5 py-2"
                > {{
                    researchInfo.action.email.template.submitButtonValue ||
                    $t('researchPage.send')
                  }}
                </b-button
              >
              <template class="modal-answer" v-if="validateFields">
                <b-modal
                  id="modal-send"
                  ref="my-modal"
                  hide-footer
                  hide-header
                  :no-close-on-backdrop="true"
                  hide-header-close
                  :visible="true"
                >
                  <b-button class="close-button" @click="hideModal">X</b-button>
                  <div class="row mt-2">
                    <div class="col-12">
                      <span
                        v-if="contactsRequired"
                        class="required mt-2"
                      >
                        *Campos obrigatórios
                      </span>
                      <div
                        v-for="(item, i) in action.email.additionalQuestions"
                        :key="i"
                      >
                        <contact
                          v-if="
                            item.type === 'CONTACT' &&
                            !item.show &&
                            !item.display
                          "
                          :type="item.displayType"
                          :questionText="
                            langView === 'br'
                              ? item.text
                              : langView === 'us'
                              ? item.textEN
                              : item.textES
                          "
                          :choices="item.choices"
                          :addQuestionTemplate="
                            researchInfo.addQuestionTemplate
                          "
                          :index="i"
                          v-model="dataContact"
                          :lang="langView"
                          :name="$route.query.name"
                          :phone="$route.query.phone"
                          :email="$route.query.email"
                        />
                      </div>
                    </div>
                  </div>
                  <b-button
                    class="mt-3"
                    block
                    variant="btn btn-primary"
                    @click="updateContactInfo"
                    >Enviar</b-button
                  >
                </b-modal>
              </template>
            </template>
            <template v-else>
              <template>
                <button
                  :disabled="loadingSubmit || isLoadingCpf"
                  :style="{
                    boxShadow: `0px 10px 30px -7px ${
                      researchInfo.action.email.template.buttonColor ||
                      '#cccccc'
                    }`,
                    backgroundColor: researchInfo.action.email.template
                      .buttonColor
                      ? researchInfo.action.email.template.buttonColor
                      : '',
                    borderColor: researchInfo.action.email.template
                      .buttonBorderColor
                      ? researchInfo.action.email.template.buttonBorderColor
                      : '',
                    color: researchInfo.action.email.template.buttonTextColor
                      ? researchInfo.action.email.template.buttonTextColor
                      : '',
                  }"
                  class="btn btn-primary px-5 py-2 btn-shadow"
                  @click="submit"
                >
                  {{
                    researchInfo.action.email.template.submitButtonValue ||
                    $t('researchPage.send')
                  }}
                </button>
              </template>
            </template>
          </div>
        </div>
        <div class="row">
          <div class="col-12 text-center mt-5">
            <hr />
            <div
              class="template-footer-modal mt-4 mb-4"
              v-if="researchInfo.footer"
            >
              <a href="https://www.indecx.com.br/">
                <img
                  src="../../../assets/logo-indecx.png"
                  style="width: 80px"
                />
              </a>
            </div>
          </div>
        </div>
        <div v-if="researchInfo.textprivacyPolicy" class="row">
          <div class="col-12 text-center mb-4">
            <span style="font-size: 0.9em"
              ><a
                :href="researchInfo.linkprivacyPolicy"
                style="color: #212529"
                target="_blank"
                :style="{
                  color:
                    researchInfo.action.email.template.scale !== 'colors'
                      ? researchInfo.action.email.template.backgroundtext
                      : '#000000',
                }"
                >{{ researchInfo.textprivacyPolicy }}</a
              ></span
            >
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="loadingSubmit" v-if="sendLoading">
      <Spinner name="wave" color="#86f470" />
      <span style="color: #fff; font-size: 20px; margin-left: -18px;"
        >Enviando...</span
      >
    </div> -->
  </div>
</template>

<script>
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { mapState, mapActions } from 'vuex';
import CountryFlag from 'vue-country-flag';
import swal from 'sweetalert';
import Spinner from 'vue-spinkit';
import bowser from 'bowser';
import axios from 'axios';
import cSat from '@/components/molecules/metrics/csat';
import nps from '@/components/molecules/metrics/nps';
import ces from '@/components/molecules/metrics/ces';
import likert from '@/components/molecules/metrics/likert';
import starRating from '@/components/molecules/metrics/reviews';
import likeDislike from '@/components/molecules/metrics/like-dislike';
import emotion from '@/components/molecules/metrics/emotion';
import multipleChoices from '@/components/molecules/metrics/multiple-choices';
import multipleChoicesCustom from '@/components/molecules/metrics/multiple-choices-custom';
import inputType from '@/components/molecules/metrics/input-type';
import inputTypeCpf from '@/components/molecules/metrics/input-type-cpf';
import contact from '@/components/molecules/metrics/contact';
import labelQuestion from '@/components/molecules/metrics/label-question';
import methodology from '@/components/molecules/action-templates/methodology';
import researchReplys from '@/components/atoms/research-replys';
import likertEmotion from '@/components/molecules/metrics/likert-emotion';
import validator from 'validator';
import Unavailable from '@/components/pages/unavailable';
import api from '../../../services/api';
import thankYouPage from '../../pages/final-pages/thank-you-page';
import searchAnswered from '../../pages/final-pages/search-already-answered';
import searchNotFound from '../../pages/final-pages/search-not-found';
import EventBus from '../../../eventBus';

export default {
  components: {
    methodology,
    cSat,
    nps,
    likert,
    starRating,
    likeDislike,
    emotion,
    multipleChoices,
    multipleChoicesCustom,
    inputType,
    inputTypeCpf,
    contact,
    researchReplys,
    labelQuestion,
    Spinner,
    ces,
    Unavailable,
    likertEmotion,
    CountryFlag,
    thankYouPage,
    searchAnswered,
    searchNotFound,
  },
  data: () => ({
    cpf: '',
    isLoadingCpf: false,
    apiCallsCount: 0,
    displayInvalidCpf: false,
    timerValue: 0,
    audio: null,
    enabledAudioResponse: false,
    headers: {
      'X-Custom-Header': 'somedata',
    },
    anonymousResponse: false,
    researchInfo: {
      reply: {},
      additionalQuestions: [],
    },
    dataContact: {
      name: null,
      email: null,
      phone: null,
    },
    logo: null,
    error: false,
    loading: true,
    answer: {},
    userAuth: null,
    feedback: '',
    apiRoot: null,
    apiServerless: null,
    loadingSubmit: false,
    errorMsg: null,
    displayRequiredFields: false,
    contactsRequired: false,
    validateInput: false,
    indicators: [],
    action: {},
    typeModalContact: false,
    answerId: null,
    validateFields: true,
    promotersGrades: [5, 4],
    passivesGrades: [3],
    detractorsGrades: [2, 1],
    closingMessage: {
      useLogo: false,
      html: null,
    },
    displayClosingMessage: false,
    closingMessageType: 'default',
    isLinkChannel: false,
    promotersQuestion: null,
    neutralQuestion: null,
    detractorsQuestion: null,
    company: null,
    sendLoading: false,
    afterAnswer: false,
    positionQuestion: null,
    showMessage: false,
    visitorId: null,
    langView: 'br',
    text: null,
    question: null,
    questionHTML: null,
    myHTML: null,
  }),
  methods: {
    ...mapActions('actions', ['setTestNpsReview']),

    shuffleArray(array) {
      for (let i = array.length - 1; i > 0; i -= 1) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
    },

    setLangView(locale) {
      this.langView = locale;

      if (this.langView === 'br') {
        this.text = this.researchInfo.text;
        this.question = this.researchInfo.action.question;
        this.questionHTML = this.researchInfo.action.questionHTML;
        this.myHTML = this.researchInfo.action.email.template.myHTML;
      }
      if (this.langView === 'us') {
        this.text = this.researchInfo.textEn;
        this.question = this.researchInfo.action.questionEn;
        this.questionHTML = this.researchInfo.action.questionHTMLEn;
        this.myHTML = this.researchInfo.action.email.template.myHTMLEn;
      }
      if (this.langView === 'es') {
        this.text = this.researchInfo.textEs;
        this.question = this.researchInfo.action.questionEs;
        this.questionHTML = this.researchInfo.action.questionHTMLEs;
        this.myHTML = this.researchInfo.action.email.template.myHTMLEs;
      }
    },

    startTimerToReloadPage() {
      if (this.researchInfo.action.reloadPage) {
        const timer = setInterval(() => {
          this.timerValue += 1;
          if (this.timerValue >= 100) {
            window.location.reload();
            clearInterval(timer);
          }
        }, 100);
      }
    },
    isVisible(item, value) {
      if (item.logicalRuleEnabled && item.conditionalRule) {
        let res = false;
        switch (item.conditionalRule) {
          case 'equal': // igual
            if (item.type === 'MULTIPLE') {
              if (!value.isMultipleChoiceCustom) {
                if (item.multipleType === 'radio') {
                  value.multipleValues = this.returnTextInBr(
                    item.choices,
                    value.multipleValues,
                  );

                  res =
                    value.multipleValues === item.conditionalValue
                      ? true
                      : false;
                } else {
                  res = value.multipleValues.includes(item.conditionalValue);
                }
              }

              if (value.isMultipleChoiceCustom) {
                if (value.options && value.options.length > 0) {
                  for (let i = 0; i < value.options.length; i += 1) {
                    if (value.options[i].text === item.conditionalValue) {
                      res = true;
                      break;
                    }
                  }
                }
              }
            } else {
              res =
                Number(value.review) === item.conditionalValue ? true : false;
            }
            break;

          case 'differentThan': // diferente
            if (item.type === 'MULTIPLE') {
              if (!value.isMultipleChoiceCustom) {
                if (item.multipleType === 'radio') {
                  value.multipleValues = this.returnTextInBr(
                    item.choices,
                    value.multipleValues,
                  );

                  res =
                    value.multipleValues !== item.conditionalValue
                      ? true
                      : false;
                } else {
                  res = value.multipleValues.includes(item.conditionalValue);
                }
              }

              if (value.isMultipleChoiceCustom) {
                if (value.options && value.options.length > 0) {
                  for (let i = 0; i < value.options.length; i += 1) {
                    if (value.options[i].text !== item.conditionalValue) {
                      res = true;
                      break;
                    }
                  }
                }
              }
            } else {
              res =
                Number(value.review) !== item.conditionalValue ? true : false;
            }
            break;

          case 'biggerThen': // maior que
            res = value.review > item.conditionalValue ? true : false;
            break;

          case 'greaterOrEqualTo': // maior ou igual
            res = value.review >= item.conditionalValue ? true : false;
            break;

          case 'lessThan': // menor que
            res = value.review < item.conditionalValue ? true : false;
            break;

          case 'lessThanOrEqualTo': // menor ou igual
            res = value.review <= item.conditionalValue ? true : false;
            break;

          default:
            break;
        }
        return res;
      }
      return false;
    },

    returnTextInBr(array, itemSelected) {
      let text;

      for (let index = 0; index < array.length; index += 1) {
        if (
          array[index].text === itemSelected ||
          array[index].textEN === itemSelected ||
          array[index].textES === itemSelected
        ) {
          text = array[index].text;
        }
      }

      return text;
    },

    getReview(value) {
      const index = Number(value.position);
      const item = this.researchInfo.additionalQuestions[index];

      let gradeQuestion = null;
      this.researchInfo.additionalQuestions[index].answerText = value.review;

      // force dom update
      if (item && item.type !== 'MULTIPLE' && item.type !== 'INPUT') {
        gradeQuestion = value.review;
      } else if (item && item.type === 'INPUT') {
        gradeQuestion = value.review;
      } else {
        gradeQuestion = value.multipleValues;
      }

      if (
        item &&
        item.type === 'INPUT-CPF' &&
        value.review.length == 14 &&
        this.researchInfo.enableApiCpf
      ) {
        this.processCpfApi(value.review, index);
      }

      this.$set(
        this.researchInfo.additionalQuestions[index],
        'gradeAddQuestion',
        gradeQuestion,
      );

      if (item && item.idsDisabled && item.idsDisabled.length > 0) {
        item.idsDisabled.forEach((el) => {
          for (
            let i = 0;
            i < this.researchInfo.additionalQuestions.length;
            i += 1
          ) {
            if (
              this.researchInfo.additionalQuestions[i].id === el &&
              value.review !== -1
            ) {
              this.researchInfo.additionalQuestions[i].show = this.isVisible(
                item,
                value,
              );

              if (!this.researchInfo.additionalQuestions[i].show) {
                this.researchInfo.additionalQuestions[i].display = false;
              } else {
                this.researchInfo.additionalQuestions.display = true;
              }
            } else {
              // this.researchInfo.additionalQuestions[i].display = false;
            }
          }
        });

        const arr = this.researchInfo.additionalQuestions;
        this.researchInfo.additionalQuestions = [];
        this.researchInfo.additionalQuestions = arr;
      }
    },

    async processCpfApi(cpf, index) {
      this.isLoadingCpf = true;
      this.displayInvalidCpf = false;
      // eslint-disable-next-line
      this.apiCallsCount++;

      try {
        const response = await api.post('/gndi-cpf-api', {
          cpf: `${cpf}`,
        });

        if (response.data) {
          const obj = response.data;

          Object.keys(obj).forEach((key) => {
            const indicatorKey = `${key}_api`;
            const indicatorIndex = this.indicators.findIndex(
              (item) =>
                item.column.toLowerCase() === indicatorKey.toLowerCase(),
            );
            if (indicatorIndex >= 0) {
              this.indicators[indicatorIndex] = {
                column: indicatorKey,
                value: obj[key],
              };
            } else {
              this.indicators.push({ column: indicatorKey, value: obj[key] });
            }
          });

          this.isLoadingCpf = false;
        }

        const indicatorCpfIndex = this.indicators.findIndex(
          (i) => i.column === 'cpf_cadastrado',
        );
        if (indicatorCpfIndex >= 0) {
          if (response.data.status !== 0) {
            this.indicators[indicatorCpfIndex] = {
              column: 'cpf_cadastrado',
              value: 'Sim',
            };
          } else {
            this.indicators[indicatorCpfIndex] = {
              column: 'cpf_cadastrado',
              value: 'Não',
            };
          }
        } else if (response.data.status !== 0) {
          this.indicators.push({ column: 'cpf_cadastrado', value: 'Sim' });
        } else {
          this.indicators.push({ column: 'cpf_cadastrado', value: 'Não' });
        }

        if (this.apiCallsCount <= 3 && response.data.status === 0) {
          this.displayInvalidCpf = true;
        }
      } catch (error) {
        this.isLoadingCpf = false;

        if (this.apiCallsCount <= 3) {
          const element = document.getElementById(`input-type-cpf-${index}`);
          element.value = '';

          this.displayInvalidCpf = true;
        }
        window.console.log('Error: ', error);
      }
    },

    callback(ev) {
      if (ev.blob) {
        this.audio = ev.blob;
      }
    },
    async blobToBase64(blob) {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      });
    },
    conditionalQuestion() {
      if (this.promotersGrades.includes(this.testNpsReview)) {
        return 'promotor';
      } else if (this.detractorsGrades.includes(this.testNpsReview)) {
        return 'detrator';
      }

      return 'neutro';
    },

    hideModal() {
      this.$refs['my-modal'].hide();
      this.updateContactInfo();
    },
    async submit() {
      this.loadingSubmit = true;

      if (this.enabledAudioResponse) {
        this.enabledAudioResponse = false;
        setTimeout(() => {
          this.enabledAudioResponse = true;
        });

        if (!this.audio) {
          await new Promise((resolve) => setTimeout(resolve, 800));
        }
      }

      const validate = this.verifyFields();
      let verifyCpf = true;

      if (this.researchInfo.enableApiCpf) {
        const inputCpf = this.researchInfo.additionalQuestions.find(
          (item) => item.type === 'INPUT-CPF',
        );
        if (inputCpf) {
          const existOnDom = document.getElementById(inputCpf.id);

          if (
            existOnDom &&
            (!this.cpf || (this.cpf && this.cpf.review.length < 14))
          ) {
            verifyCpf = false;
            this.errorMsg = 'Por favor, informe o CPF completo!';
          }

          if (this.displayInvalidCpf && existOnDom) {
            verifyCpf = false;
            this.errorMsg = 'Por favor, verifique o campo CPF!';
          }
        }
      }

      const contactModalInForm = this.researchInfo.additionalQuestions.some(
        (item) => item.displayType ===  'afterSendAnswer',
      );

      // so mostra o modal de contato se tiver validado os dados do formulario
      if(validate && contactModalInForm) {
        this.typeModalContact = true;
      } else {
        this.typeModalContact = false;
      }

      if (validate && verifyCpf) {
        this.answer.companyId = this.action.companyId;
        this.answer.actionId = this.$route.params.actionId;
        this.answer.name = this.dataContact.name;
        this.answer.email = this.dataContact.email;
        this.answer.phone = this.dataContact.phone;
        this.answer.review = this.testNpsReview;
        this.answer.feedback = this.feedback;
        this.answer.additionalQuestions = this.researchInfo.additionalQuestions;
        this.answer.channel = this.isLinkChannel ? 'link' : 'qrcode';
        this.answer.token = null;
        this.answer.indicators = this.indicators;
        this.answer.anonymousResponse = !this.researchInfo.enableAnonymous
          ? this.researchInfo.enableAnonymous
          : this.anonymousResponse;


        this.answer.deviceInfo = this.getDeviceInfo();
        this.answer.deviceInfo.visitorId = this.visitorId;

        this.answer.additionalQuestions.forEach((el, index) => {
          if (this.langView === 'br') {
            el.text = el.text;
          } else if (this.langView === 'us') {
            el.text = el.textEN;
          } else if (this.langView === 'es') {
            el.text = el.textES;
          }

          if (el.addQuestionAnswer) {
            el.review = el.addQuestionAnswer.review;
            el.comment = el.addQuestionAnswer.comment || undefined;

            if (this.getConditionalQuestion(el) !== '') {
              el.conditionalQuestion = this.getConditionalQuestion(el);
            }

            el.isAnswered = this.getIsAnswered(el);
          }

          if (this.getConditionalQuestion(el) !== '') {
            el.conditionalQuestion = this.getConditionalQuestion(el);
          }

          delete this.answer.additionalQuestions[index].addQuestionAnswer;

          if (el.addQuestionAnswerMultiple) {
            if (el.template !== 'withSubOptions') {
              el.multipleValues =
                el.addQuestionAnswerMultiple.multipleValues || [];
            } else if (el.template === 'withSubOptions') {
              el.options = el.addQuestionAnswerMultiple.options || [];
            }

            if (!el.template || el.template !== 'withSubOptions') {
              // limpa os campos selecionados se nao mostrou mais essa pergunta para o usuario - regra condicional
              if (el.show) {
                el.multipleValues = [];
              }
            }

            el.comment = el.addQuestionAnswerMultiple.comment || undefined;
            el.conditionalQuestion = this.getConditionalQuestion(el);
            el.isAnswered = this.getIsAnswered(el);
          }

          if (el.show) {
            // se a pergunta nao aparece na tela, limpa as notas atribuidas a ela
            el.review = null;
            el.answerText = null;
          }

          delete this.answer.additionalQuestions[index]
            .addQuestionAnswerMultiple;

          if (el.profileEnabled) {
            if (
              el.selectedProfile === 'detrator' &&
              !this.detractorsGrades.includes(this.answer.review)
            ) {
              this.researchInfo.additionalQuestions[index].options = [];
            } else if (
              el.selectedProfile === 'neutro' &&
              !this.passivesGrades.includes(this.answer.review)
            ) {
              this.researchInfo.additionalQuestions[index].options = [];
            } else if (
              el.selectedProfile === 'promotor' &&
              !this.promotersGrades.includes(this.answer.review)
            ) {
              this.researchInfo.additionalQuestions[index].options = [];
            }
          }
        });

        try {
          let response;

          if (this.audio) {
            this.answer.audioBase64 = await this.blobToBase64(this.audio);
          } else {
            this.answer.audioBase64 = null;
          }

          // serverless test
          if (this.company.enableServerless && this.apiServerless) {
            response = await axios.post(`${this.apiServerless}/answer-qrcode`, {
              answer: this.answer,
            });
          } else {
            response = await api.post(`/qrcode-answers`, {
              answer: this.answer,
            });
          }

          this.answerId = response ? response.data._id : '';

          this.handleClosingMessage();

          if (!this.typeModalContact) {
            this.displayClosingMessage = true;
            this.startTimerToReloadPage();
          }
        } catch (error) {
          swal(
            this.$t('researchPage.errorMsg.title'),
            this.$t('researchPage.errorMsg.description'),
            'error',
          );
        }
      } else {
        swal('Oops...', this.errorMsg, 'warning');
      }
      this.loadingSubmit = false;
    },

    async updateContactInfo() {
      let isValid = true;
      this.contactsRequired = false;

      // obrigatorio por pergunta adicional
      if (!this.researchInfo.allAnswersRequired) {
        for (
          let i = 0;
          i < this.researchInfo.additionalQuestions.length;
          i += 1
        ) {
          const question = this.researchInfo.additionalQuestions[i];
          if (question.type === 'CONTACT') {
            const contactTypes = question.choices || [];
            const hasName = contactTypes.indexOf('name');
            const hasPhone = contactTypes.indexOf('phone');
            const hasEmail = contactTypes.indexOf('email');

            if (hasName >= 0 && !this.dataContact.name) {
              isValid = question.mandatory ? false : true;
              this.contactsRequired = question.mandatory ? true : false;
              break;
            }

            if (hasEmail >= 0 && !this.dataContact.email) {
              isValid = question.mandatory ? false : true;
              this.contactsRequired = true;
              break;
            }

            if (
              this.dataContact.email &&
              !validator.isEmail(this.dataContact.email)
            ) {
              swal(
                this.$t('researchPage.errorMsg.title'),
                'Insira um e-mail válido',
                'warning',
              );

              this.contactsRequired = question.mandatory ? true : false;
            }
            if (hasPhone >= 0 && !this.dataContact.phone) {
              isValid = question.mandatory ? false : true;
              this.contactsRequired = question.mandatory ? true : false;
              break;
            }
          }
        }

        if (isValid) {
          // serverless test
          if (this.company.enableServerless && this.apiServerless) {
            await axios.put(
              `${this.apiServerless}/answer/data-contact/${this.answerId}`,
              {
                name: this.dataContact.name,
                email: this.dataContact.email,
                phone: this.dataContact.phone,
              },
            );
          } else {
            await api.put(`/answer/data-contact/${this.answerId}`, {
              name: this.dataContact.name,
              email: this.dataContact.email,
              phone: this.dataContact.phone,
            });
          }
          this.displayClosingMessage = true;
          this.startTimerToReloadPage();
        }
      } else if (
        this.dataContact.email &&
        !validator.isEmail(this.dataContact.email)
      ) {
        swal(
          this.$t('researchPage.errorMsg.title'),
          'Insira um e-mail válido',
          'warning',
        );
      }

      // quando todas perguntas adicionais sao obrigatorias
      if (this.researchInfo.allAnswersRequired) {
        for (
          let i = 0;
          i < this.researchInfo.additionalQuestions.length;
          i += 1
        ) {
          const question = this.researchInfo.additionalQuestions[i];
          if (question.type === 'CONTACT') {
            const contactTypes = question.choices || [];
            const hasName = contactTypes.indexOf('name');
            const hasPhone = contactTypes.indexOf('phone');
            const hasEmail = contactTypes.indexOf('email');

            if (hasName >= 0 && !this.dataContact.name) {
              isValid = false;
              this.contactsRequired = true;
              break;
            }

            if (hasEmail >= 0 && !this.dataContact.email) {
              isValid = false;
              this.contactsRequired = true;
              break;
            }

            if (
              this.dataContact.email &&
              !validator.isEmail(this.dataContact.email)
            ) {
              swal(
                this.$t('researchPage.errorMsg.title'),
                'Insira um e-mail válido',
                'warning',
              );
              isValid = false;
              this.contactsRequired = true;
            }

            if (hasPhone >= 0 && !this.dataContact.phone) {
              isValid = false;
              this.contactsRequired = true;
              break;
            }
          }
        }

        if (isValid) {
          // serverless test
          if (this.company.enableServerless && this.apiServerless) {
            await axios.put(
              `${this.apiServerless}/answer/data-contact/${this.answerId}`,
              {
                name: this.dataContact.name,
                email: this.dataContact.email,
                phone: this.dataContact.phone,
              },
            );
          } else {
            await api.put(`/answer/data-contact/${this.answerId}`, {
              name: this.dataContact.name,
              email: this.dataContact.email,
              phone: this.dataContact.phone,
            });
          }
          this.displayClosingMessage = true;
          this.startTimerToReloadPage();
        }
      } else if (
        this.dataContact.email &&
        !validator.isEmail(this.dataContact.email)
      ) {
        swal(
          this.$t('researchPage.errorMsg.title'),
          'Insira um e-mail válido',
          'warning',
        );
      }
    },

    // return an array with the questions shown on the screen
    fillArrayAll() {
      const arr = [];

      this.researchInfo.additionalQuestions.forEach((el) => {
        if (el.selectedProfile) {
          if (
            this.promotersGrades.includes(this.testNpsReview) &&
            el.selectedProfile.includes('promotor') &&
            !el.show
          ) {
            arr.push({
              answerText: el.answerText,
              applicableEnabled: el.applicableEnabled,
              commentEnabled: el.commentEnabled,
              profileEnabled: el.profileEnabled,
              // eslint-disable-next-line no-nested-ternary
              review: el.addQuestionAnswer
                ? el.addQuestionAnswer.review
                : el.review
                ? el.review
                : null,
              selectedProfile: el.selectedProfile,
              text: el.text,
              type: el.type,
              addQuestionAnswerMultiple: el.addQuestionAnswerMultiple,
              choices: el.choices,
              indicatorValue: el.indicatorValue,
              indicatorValueEnabled: el.indicatorValueEnabled,
              selectedIndicator: el.selectedIndicator,
              feedback: el.feedback,
              mandatory: el.mandatory,
              id: el.id,
              displayType: el.displayType,
              indicatorCriterion: el.indicatorCriterion,
              mandatorySubOption: el.mandatorySubOption,
            });
          } else if (
            this.passivesGrades.includes(this.testNpsReview) &&
            el.selectedProfile.includes('neutro') &&
            !el.show
          ) {
            arr.push({
              answerText: el.answerText,
              applicableEnabled: el.applicableEnabled,
              commentEnabled: el.commentEnabled,
              profileEnabled: el.profileEnabled,
              // eslint-disable-next-line no-nested-ternary
              review: el.addQuestionAnswer
                ? el.addQuestionAnswer.review
                : el.review
                ? el.review
                : null,
              selectedProfile: el.selectedProfile,
              text: el.text,
              type: el.type,
              addQuestionAnswerMultiple: el.addQuestionAnswerMultiple,
              choices: el.choices,
              indicatorValue: el.indicatorValue,
              indicatorValueEnabled: el.indicatorValueEnabled,
              selectedIndicator: el.selectedIndicator,
              feedback: el.feedback,
              mandatory: el.mandatory,
              id: el.id,
              displayType: el.displayType,
              indicatorCriterion: el.indicatorCriterion,
              mandatorySubOption: el.mandatorySubOption,
            });
          } else if (
            this.detractorsGrades.includes(this.testNpsReview) &&
            el.selectedProfile.includes('detrator') &&
            !el.show
          ) {
            arr.push({
              answerText: el.answerText,
              applicableEnabled: el.applicableEnabled,
              commentEnabled: el.commentEnabled,
              profileEnabled: el.profileEnabled,
              // eslint-disable-next-line no-nested-ternary
              review: el.addQuestionAnswer
                ? el.addQuestionAnswer.review
                : el.review
                ? el.review
                : null,
              selectedProfile: el.selectedProfile,
              text: el.text,
              type: el.type,
              addQuestionAnswerMultiple: el.addQuestionAnswerMultiple,
              choices: el.choices,
              indicatorValue: el.indicatorValue,
              indicatorValueEnabled: el.indicatorValueEnabled,
              selectedIndicator: el.selectedIndicator,
              feedback: el.feedback,
              mandatory: el.mandatory,
              id: el.id,
              displayType: el.displayType,
              indicatorCriterion: el.indicatorCriterion,
              mandatorySubOption: el.mandatorySubOption,
            });
          }
        } else if (!el.show || el.logicalRuleEnabled) {
          arr.push({
            answerText: el.answerText,
            applicableEnabled: el.applicableEnabled,
            commentEnabled: el.commentEnabled,
            profileEnabled: el.profileEnabled,
            // eslint-disable-next-line no-nested-ternary
            review: el.addQuestionAnswer
              ? el.addQuestionAnswer.review
              : el.review
              ? el.review
              : null,
            selectedProfile: el.selectedProfile,
            text: el.text,
            type: el.type,
            addQuestionAnswerMultiple: el.addQuestionAnswerMultiple,
            choices: el.choices,
            indicatorValue: el.indicatorValue,
            indicatorValueEnabled: el.indicatorValueEnabled,
            selectedIndicator: el.selectedIndicator,
            feedback: el.feedback,
            mandatory: el.mandatory,
            id: el.id,
            displayType: el.displayType,
            indicatorCriterion: el.indicatorCriterion,
            mandatorySubOption: el.mandatorySubOption,
          });
        } else if (
          (el.selectedProfile === null && !el.show) ||
          (el.selectedProfile === undefined && !el.show)
        ) {
          arr.push({
            answerText: el.answerText,
            applicableEnabled: el.applicableEnabled,
            commentEnabled: el.commentEnabled,
            profileEnabled: el.profileEnabled,
            // eslint-disable-next-line no-nested-ternary
            review: el.addQuestionAnswer
              ? el.addQuestionAnswer.review
              : el.review
              ? el.review
              : null,
            selectedProfile: el.selectedProfile,
            text: el.text,
            type: el.type,
            addQuestionAnswerMultiple: el.addQuestionAnswerMultiple,
            choices: el.choices,
            indicatorValue: el.indicatorValue,
            indicatorValueEnabled: el.indicatorValueEnabled,
            selectedIndicator: el.selectedIndicator,
            feedback: el.feedback,
            mandatory: el.mandatory,
            id: el.id,
            displayType: el.displayType,
            indicatorCriterion: el.indicatorCriterion,
            mandatorySubOption: el.mandatorySubOption,
          });
        }
      });

      return arr;
    },

    verifyExistsDom(id) {
      return document.getElementById(id);
    },

    verifyFields() {
      this.errorMsg = null;

      if (this.researchInfo.allAnswersRequired) {
        let isValid = true;

        let arr = [];

        arr = this.fillArrayAll();

        for (let i = 0; i < arr.length; i += 1) {
          const question = arr[i];

          const showQuestion = this.indicatorValuedQuestion(question);

          if (showQuestion) {
            const existOnDom = document.getElementById(question.id);
            if (
              existOnDom &&
              !question.review &&
              question.review !== 0 &&
              question.type !== 'MULTIPLE' &&
              question.type !== 'LABEL' &&
              question.type !== 'INPUT' &&
              question.type !== 'INPUT-CPF' &&
              question.type !== 'CONTACT'
            ) {
              isValid = false;
              this.validateFields = false;
              break;
            }
            if (question.type !== 'LABEL') {
              if (question.type === 'MULTIPLE') {
                if (
                  existOnDom &&
                  question.addQuestionAnswerMultiple.multipleValues &&
                  question.addQuestionAnswerMultiple.multipleValues.length <=
                    0 &&
                  question.choices.length === 0
                ) {
                  isValid = false;
                  this.validateFields = false;
                  break;
                }

                if (
                  question.mandatorySubOption &&
                  question.mandatorySubOption !== undefined
                ) {
                  if (
                    question.addQuestionAnswerMultiple.options &&
                    question.addQuestionAnswerMultiple.options.length === 0
                  ) {
                    isValid = false;
                    this.validateFields = false;
                    break;
                  }

                  if (
                    question.addQuestionAnswerMultiple.options &&
                    question.addQuestionAnswerMultiple.options.length > 0
                  ) {
                    const listSubOptionsIsEmpty =
                      question.addQuestionAnswerMultiple.options.some(
                        (item) => item.subOptions.length === 0,
                      );
                    if (listSubOptionsIsEmpty) {
                      isValid = false;
                      this.validateFields = false;
                      break;
                    }
                  }
                }
              } else if (
                question.type === 'INPUT' ||
                question.type === 'INPUT-CPF'
              ) {
                if (existOnDom && !question.answerText) {
                  isValid = false;
                  this.validateFields = false;
                  break;
                }
              } else if (question.type === 'CONTACT') {
                const contactTypes = question.choices || [];
                const hasName = contactTypes.indexOf('name');
                const hasEmail = contactTypes.indexOf('email');
                const hasPhone = contactTypes.indexOf('phone');

                if (question.displayType === 'formSearch') {
                  if (hasName >= 0 && !this.dataContact.name) {
                    isValid = false;
                    this.validateFields = false;
                    break;
                  }

                  if (hasEmail >= 0 && !this.dataContact.email) {
                    isValid = false;
                    this.validateFields = false;
                    break;
                  }

                  if (hasPhone >= 0 && !this.dataContact.phone) {
                    isValid = false;
                    this.validateFields = false;
                    break;
                  }
                }
              } else if (
                this.testNpsReview === null ||
                this.testNpsReview === undefined
              ) {
                isValid = false;
                this.validateFields = false;
                break;
              }
            }
          }
        }

        if (!this.researchInfo.action.feedbackDisabled && !this.feedback) {
          isValid = false;
          this.validateFields = false;
        }

        if (!isValid) {
          this.errorMsg = 'Por favor, preencha todos os campos obrigatórios.';
          this.displayRequiredFields = true;
        }
      }

      if (this.researchInfo.customMandatoryQuestion) {
        let isValid = true;

        let arr = [];

        arr = this.fillArrayAll();

        let fields = [];

        arr.forEach((element) => {
          if (element.type !== 'REVIEWS') {
            fields = arr.filter(
              (item) => item.mandatory && item.review === null,
            );
          }
        });

        if (fields.length) {
          this.showMessage = true;
        } else {
          this.showMessage = false;
        }

        for (let i = 0; i < arr.length; i += 1) {
          const question = arr[i];

          const showQuestion = this.indicatorValuedQuestion(question);

          if (showQuestion) {
            const existOnDom = document.getElementById(question.id);

            if (
              !question.review &&
              question.review !== 0 &&
              question.type !== 'MULTIPLE' &&
              question.type !== 'LABEL' &&
              question.type !== 'INPUT' &&
              question.type !== 'INPUT-CPF' &&
              question.type !== 'CONTACT' &&
              question.mandatory &&
              existOnDom
            ) {
              this.validateFields = false;
              isValid = false;
              break;
            }
            if (question.type !== 'LABEL') {
              if (question.type === 'MULTIPLE') {
                if (
                  existOnDom &&
                  question.addQuestionAnswerMultiple.multipleValues &&
                  question.addQuestionAnswerMultiple.multipleValues.length <=
                    0 &&
                  question.mandatory
                ) {
                  this.validateFields = false;
                  isValid = false;
                  break;
                }

                if (
                  question.mandatorySubOption &&
                  question.mandatorySubOption !== undefined
                ) {
                  if (
                    question.addQuestionAnswerMultiple.options &&
                    question.addQuestionAnswerMultiple.options.length === 0
                  ) {
                    isValid = false;
                    this.validateFields = false;
                    break;
                  }

                  if (
                    question.addQuestionAnswerMultiple.options &&
                    question.addQuestionAnswerMultiple.options.length > 0
                  ) {
                    const listSubOptionsIsEmpty =
                      question.addQuestionAnswerMultiple.options.some(
                        (item) => item.subOptions.length === 0,
                      );
                    if (listSubOptionsIsEmpty) {
                      isValid = false;
                      this.validateFields = false;
                      break;
                    }
                  }
                }
              } else if (
                question.type === 'INPUT' ||
                question.type === 'INPUT-CPF'
              ) {
                if (existOnDom && !question.answerText && question.mandatory) {
                  this.validateFields = false;
                  isValid = false;
                  break;
                }
              } else if (question.type === 'CONTACT' && question.mandatory) {
                const contactTypes = question.choices || [];
                const hasName = contactTypes.indexOf('name');
                const hasEmail = contactTypes.indexOf('email');
                const hasPhone = contactTypes.indexOf('phone');

                if (question.displayType === 'formSearch') {
                  if (hasName >= 0 && !this.dataContact.name) {
                    this.validateFields = false;
                    isValid = false;
                    this.contactsRequired = true;
                    break;
                  }

                  if (hasEmail >= 0 && !this.dataContact.email) {
                    this.validateFields = false;
                    isValid = false;
                    this.contactsRequired = true;
                    break;
                  }

                  if (hasPhone >= 0 && !this.dataContact.phone) {
                    this.validateFields = false;
                    isValid = false;
                    this.contactsRequired = true;
                    break;
                  }
                }
              } else if (
                this.testNpsReview === null ||
                this.testNpsReview === undefined
              ) {
                this.validateFields = false;
                isValid = false;
                break;
              }
            }
          }
        }

        // if (!this.feedback) {
        //   isValid = false;
        //   this.validateFields = false;
        // }

        if (!isValid) {
          this.errorMsg = 'Por favor, preencha todos os campos obrigatórios.';
        }
      }

      if (!Number.isInteger(this.testNpsReview)) {
        if (this.langView === 'br') {
          this.errorMsg =
            'Por favor, responda nossa pergunta principal para enviar a resposta.';
        } else if (this.langView === 'us') {
          this.errorMsg =
            'Please answer our main question to submit the answer.';
        } else {
          this.errorMsg =
            'Responda nuestra pregunta principal para enviar la respuesta.';
        }
      }

      if (
        this.researchInfo.metric === 'nps-0-10' &&
        this.testNpsReview < 0 &&
        this.testNpsReview > 10
      ) {
        this.errorMsg =
          'Por favor, responda nossa pergunta principal para enviar a resposta.';
      }

      if (
        this.researchInfo.metric === 'nps-1-5' &&
        this.testNpsReview < 1 &&
        this.testNpsReview > 5
      ) {
        this.errorMsg =
          'Por favor, responda nossa pergunta principal para enviar a resposta.';
      }

      if (
        this.dataContact.email &&
        !validator.isEmail(this.dataContact.email)
      ) {
        this.errorMsg = 'Por favor, insira um e-mail válido.';
      }

      if (this.errorMsg) {
        this.validateFields = false;
        return false;
      }

      this.validateFields = true;
      return true;
    },

    handleClosingMessage() {
      if (
        this.researchInfo.closingMessageEnabled &&
        this.researchInfo.closingMessage
      ) {
        if (this.researchInfo.closingMessage.dynamic) {
          if (
            this.researchInfo.closingMessage.promoters &&
            this.promotersGrades.includes(this.testNpsReview)
          ) {
            this.closingMessage.useLogo =
              this.researchInfo.closingMessage.promoters.useLogo;
            this.closingMessage.html =
              this.researchInfo.closingMessage.promoters.html;
          } else if (
            this.researchInfo.closingMessage.passives &&
            this.passivesGrades.includes(this.testNpsReview)
          ) {
            this.closingMessage.useLogo =
              this.researchInfo.closingMessage.passives.useLogo;
            this.closingMessage.html =
              this.researchInfo.closingMessage.passives.html;
          } else if (
            this.researchInfo.closingMessage.detractors &&
            this.detractorsGrades.includes(this.testNpsReview)
          ) {
            this.closingMessage.useLogo =
              this.researchInfo.closingMessage.detractors.useLogo;
            this.closingMessage.html =
              this.researchInfo.closingMessage.detractors.html;
          }
        } else if (this.researchInfo.closingMessage.default) {
          this.closingMessage.useLogo =
            this.researchInfo.closingMessage.default.useLogo;
          this.closingMessage.html =
            this.researchInfo.closingMessage.default.html;

          if (this.langView === 'us') {
            this.closingMessage.html =
              this.researchInfo.closingMessage.default.htmlEn;
          } else if (this.langView === 'es') {
            this.closingMessage.html =
              this.researchInfo.closingMessage.default.htmlEs;
          }
        }

        if (this.closingMessage && this.closingMessage.html) {
          this.closingMessage.html = this.closingMessage.html.replace(
            /<img src/gi,
            '<img style="max-width: 100%;" src',
          );
        }
      }
    },

    getIsAnswered(questions) {
      if (questions.profileEnabled) {
        if (questions.conditionalQuestion) {
          if (questions.review) {
            return true;
          }

          if (questions.type === 'MULTIPLE') {
            if (
              questions.multipleValues &&
              questions.multipleValues.length > 0
            ) {
              return true;
            }
            return false;
          }

          return false;
        }
      }

      return null;
    },

    // returns null to show the conditional responses displayed on the screen in the response form
    getConditionalQuestion(questions) {
      if (questions.profileEnabled && !questions.show) {
        return questions.selectedProfile;
      } else if (
        (questions.logicalRuleEnabled && !questions.show) ||
        (!questions.logicalRuleEnabled && !questions.show)
      ) {
        return null;
      }

      return '';
    },

    getDeviceInfo() {
      let deviceInfo = null;
      try {
        deviceInfo = bowser.parse(window.navigator.userAgent);
      } catch (error) {
        window.console.log(error);
      }
      return deviceInfo;
    },
    async loadDeviceUUID() {
      const useFingerprintJS = false;
      if (useFingerprintJS) {
        const fpPromise = FingerprintJS.load();
        const fp = await fpPromise;
        const result = await fp.get();
        this.visitorId = result.visitorId;
      } else {
        // Obter informações do navegador
        const browserInfo = {
          userAgent: navigator.userAgent,
          cooke: document.cookie,
        };

        // Obter informações de resolução
        const resolution = {
          screenWidth: screen.width,
          screenHeight: screen.height,
          devicePixelRatio: window.devicePixelRatio,
        };

        // Combinar informações em um objeto
        const hashInfo = {
          browser: browserInfo,
          resolution,
        };

        // Codificar o objeto em uma string JSON e depois em base64
        const hash = btoa(JSON.stringify(hashInfo));

        this.visitorId = hash;
      }
    },
    replaceTagsOnText(researchInfo, value) {
      const arrayOfTags = [];
      arrayOfTags.push(
        {
          key: 'nota',
          value: value ? value : ' ',
        },
        {
          key: 'pnota',
          value: value ? value : ' ',
        },
      );
      let promoters = researchInfo.reply.promoters;
      let neutral = researchInfo.reply.neutral;
      let detractors = researchInfo.reply.detractors;
      arrayOfTags.forEach((tag) => {
        const regexTags = new RegExp(`<${tag.key}>`, 'gi');
        if (tag.value === ' ') {
          tag.value = 0;
        }
        if (promoters) {
          promoters = promoters.replace(regexTags, tag.value);
        }
        this.promotersQuestion = promoters;
        if (neutral) {
          neutral = neutral.replace(regexTags, tag.value);
        }
        this.neutralQuestion = neutral;
        if (detractors) {
          detractors = detractors.replace(regexTags, tag.value);
        }
        this.detractorsQuestion = detractors;
      });
    },
    indicatorValuedQuestion(item) {
      if (item.indicatorValueEnabled) {
        for (let i = 0; i < this.indicators.length; i += 1) {
          if (item.indicatorCriterion === 'equal') {
            if (
              item.selectedIndicator &&
              this.indicators[i].column.toLowerCase() ===
                item.selectedIndicator.toLowerCase()
            ) {
              if (
                this.indicators[i].value.toLowerCase() ===
                item.indicatorValue.toLowerCase()
              ) {
                return true;
              }
              break;
            }
          } else if (item.indicatorCriterion === 'different') {
            if (
              item.selectedIndicator &&
              this.indicators[i].column.toLowerCase() ===
                item.selectedIndicator.toLowerCase()
            ) {
              if (
                this.indicators[i].value.toLowerCase() !==
                item.indicatorValue.toLowerCase()
              ) {
                return true;
              }
              break;
            }
          } else if (item.indicatorCriterion === 'contains') {
            if (
              item.selectedIndicator &&
              this.indicators[i].column.toLowerCase() ===
                item.selectedIndicator.toLowerCase()
            ) {
              if (
                this.indicators[i].value
                  .normalize('NFD')
                  .replace(/[\u0300-\u036f]/g, '') // remove accents
                  .toLowerCase()
                  .includes(
                    item.indicatorValue
                      .normalize('NFD')
                      .replace(/[\u0300-\u036f]/g, '')
                      .toLowerCase(),
                  )
              ) {
                return true;
              }
              break;
            }
          }
        }
        return false;
      }
      return true;
    },

    returnLang(dataAction) {
      if (dataAction.enableTranslation) {
        if (dataAction.action.email.template.enableMyHTMLPt) {
          this.langView = 'br';
        } else if (dataAction.action.email.template.enableMyHTMLEn) {
          this.langView = 'us';
        } else {
          this.langView = 'es';
        }
      } else {
        this.langView = 'br';
      }

      return this.langView;
    },
  },
  computed: {
    ...mapState('actions', ['testNpsReview']),
  },
  watch: {
    testNpsReview: function watchGrade(value) {
      this.replaceTagsOnText(this.researchInfo, value);
    },
  },
  async created() {
    this.apiRoot = process.env.API_ROOT;
    this.apiServerless = process.env.API_SERVERLESS;
    try {
      const params = this.$route.query;
      const id = params.id;
      this.isLinkChannel = this.$route.path.includes('/survey-link/');
      this.indicators = [];
      if (!this.isLinkChannel) {
        if (id) {
          const responseIndicators = await api.get(
            `/qrcode-indicators/${this.$route.params.actionId}`,
            {
              params: { id },
            },
          );
          this.indicators = responseIndicators.data;
        } else {
          Object.keys(params).forEach((key) => {
            this.indicators.push({ column: key, value: params[key] });
          });
        }
      } else {
        Object.keys(params).forEach((key) => {
          if (key !== 'name' && key !== 'email' && key !== 'phone') {
            this.indicators.push({ column: key, value: params[key] });
          } else if (key === 'name') {
            this.dataContact.name = params[key];
          } else if (key === 'email') {
            this.dataContact.email = params[key];
          } else if (key === 'phone') {
            this.dataContact.phone = params[key];
          }
        });
      }
      const response = await api.get(
        `/qrcode-research-info/${this.$route.params.actionId}`,
        {
          params,
        },
      );

      this.researchInfo = response.data;

      this.langView = this.returnLang(this.researchInfo);

      const companyData = await api.get(
        `/surveys/companies/${this.researchInfo.action.companyId}`,
      );

      this.company = companyData.data;
      this.action = this.researchInfo.action;
      if (this.researchInfo.action.allAnswersAnonymous) {
        this.anonymousResponse = true;
      }
      if (this.researchInfo.enabledAudioResponse) {
        this.enabledAudioResponse = true;
      }

      this.replaceTagsOnText(this.researchInfo);
      this.setTestNpsReview(parseInt(this.$route.params.grade, 10));
      this.researchInfo.additionalQuestions.forEach((el) => {
        if (el.type === 'MULTIPLE') {
          el.addQuestionAnswerMultiple = {
            multipleValues: [],
            comment: null,
          };

          if (el.isRandomizeQuestionOrder) {
            this.shuffleArray(el.choices);
            const choices = el.choices;
            if (choices.length > 0) {
              for (let j = 0; j < choices.length; j += 1) {
                if (choices[j].subChoices && choices[j].subChoices.length > 0) {
                  this.shuffleArray(choices[j].subChoices);
                }
              }
            }
          }
        } else if (el.type === 'MULTIPLE' && el.template === 'withSubOptions') {
          el.addQuestionAnswerMultiple = {
            options: [],
            comment: null,
          };

          if (el.isRandomizeQuestionOrder) {
            this.shuffleArray(el.choices);
            const choices = el.choices;
            if (choices.length > 0) {
              for (let j = 0; j < choices.length; j += 1) {
                if (choices[j].subChoices && choices[j].subChoices.length > 0) {
                  this.shuffleArray(choices[j].subChoices);
                }
              }
            }
          }
        } else if (el.type === 'INPUT' || el.type === 'INPUT-CPF') {
          el.answerText = null;
        } else if (el.type === 'CONTACT') {
          if (el.displayType === 'afterSendAnswer') {
            // this.typeModalContact = true;
          }
        } else {
          el.addQuestionAnswer = {
            review: null,
            comment: null,
          };
        }
      });
      if (this.researchInfo.metric.includes('0-10')) {
        this.promotersGrades = [10, 9];
        this.passivesGrades = [8, 7];
        this.detractorsGrades = [6, 5, 4, 3, 2, 1, 0];
      }

      if (this.researchInfo.metric === 'like-dislike') {
        this.promotersGrades = [1];
        this.detractorsGrades = [0];
      }

      const logoUrl = process.env.INDECX_FILES_BUCKET;
      this.logo = `${logoUrl}/${this.researchInfo.logo}`;

      this.loading = false;
    } catch (error) {
      this.loading = false;
      this.error = error.response.data.message;
    }

    if (this.langView === 'br') {
      this.text = this.researchInfo.text;
      this.question = this.researchInfo.action.question;
      this.questionHTML = this.researchInfo.action.questionHTML;
      this.myHTML = this.researchInfo.action.email.template.myHTML;
    }
    if (this.langView === 'us') {
      this.text = this.researchInfo.textEn;
      this.question = this.researchInfo.action.questionEn;
      this.questionHTML = this.researchInfo.action.questionHTMLEn;
      this.myHTML = this.researchInfo.action.email.template.myHTMLEn;
    }
    if (this.langView === 'es') {
      this.text = this.researchInfo.textEs;
      this.question = this.researchInfo.action.questionEs;
      this.questionHTML = this.researchInfo.action.questionHTMLEs;
      this.myHTML = this.researchInfo.action.email.template.myHTMLEs;
    }
  },
  mounted() {
    // adicionado para contornar o bug do touch no evento :hover em dispositivos mobile
    document.addEventListener(
      'touchstart',
      function addtouchclass(e) {
        // first time user touches the screen
        document.documentElement.classList.add('can-touch'); // add "can-touch" class to document root using classList API
        document.removeEventListener('touchstart', addtouchclass, false); // de-register touchstart event
      },
      false,
    );
    this.loadDeviceUUID();
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
.loadingSubmit {
  position: fixed;
  z-index: 99999;
  height: 50%;
  width: 2em;
  overflow: visible;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  opacity: 1;
}

.sk-wave {
  width: 50px;
  height: 180px;
  text-align: center;
  font-size: 10px;
}

.closing-message-area {
  display: flex;
  flex-direction: column;
  i {
    font-size: 92px;
    color: #009bdb;
  }
  h4 {
    color: #009bdb;
  }
}
.error-area {
  display: flex;
  flex-direction: column;
  i {
    font-size: 92px;
    color: #009bdb;
  }
  h4 {
    color: #009bdb;
  }
}

.dark-mode {
  filter: brightness(50%);
}

.wrapp {
  background-color: $gray-lighter;
  position: relative;
  min-height: 100vh;
  max-height: 100vh;
  overflow: auto;
}

.container {
  min-height: 100vh;
  background-color: #fff;
}
.question {
  font-size: 1.1rem;
}
.required {
  color: red;
  font-size: 12px;
}
</style>

<style>
.close-button {
  float: right;
  background-color: white;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/research-page-qrcode/index.vue